// extracted by mini-css-extract-plugin
export default {"overview__container":"PermanentLoadsOverview_overview__container__xZYKq"};